module.exports = __webpack_public_path__ + "assets/img/right_item01.2e47c2e5.png";